import React, { useState, useRef, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
    Chip,
    CircularProgress,
    Box,
} from '@mui/material';
import html2canvas from 'html2canvas';
import RequestService from '../../services/RequestService';
import logoImage from '../../assets/images/gameup_dark.png';
import jsPDF from 'jspdf';

const AdminCardDialog = ({ open, onClose, cardId, company }) => {
    const [qrCodeImg, setQrCodeImg] = useState('');
    const [loading, setLoading] = useState(false);
    const cardRef = useRef();
    const logoRef = useRef();

    useEffect(() => {
        if (open) {
            handleGenerateQrCode();
        }
    }, [open]);

    const handleGenerateQrCode = async () => {
        if (!cardId) return;

        setLoading(true);
        try {
            const response =
                await RequestService.generateCardCodeAsAdmin(cardId);
            const binaryData = atob(response.data);
            const byteNumbers = new Uint8Array(binaryData.length);

            for (let i = 0; i < binaryData.length; i++) {
                byteNumbers[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([byteNumbers], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);

            setQrCodeImg(imageUrl);
        } catch (err) {
            console.error('Erro ao gerar QR Code:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadPNG = async () => {
        if (!cardRef.current) return;

        setLoading(true);
        try {
            const card = cardRef.current.querySelector('div');

            const canvas = await html2canvas(card, {
                useCORS: true,
                allowTaint: false,
                crossOrigin: 'anonymous',
                logging: false,
                scale: 3,
            });
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'cm',
                format: [8.6, 5.4],
            });
            pdf.addImage(imgData, 'PNG', 0, 0, 5.4, 8.6);

            pdf.save(`player_card_${cardId}.pdf`);
        } catch (err) {
            console.error('Error generating PDF:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    color: '#0C3466',
                    fontWeight: '600',
                }}
            >
                Cartão de Acesso
            </DialogTitle>
            <DialogContent>
                {cardId && (
                    <>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '16px',
                                color: '#0C3466',
                                fontWeight: '600',
                                marginBottom: '8px',
                            }}
                        >
                            Pré-visualização
                        </Typography>
                        <Box
                            ref={cardRef}
                            sx={{
                                // backgroundColor: '#EDF8FF',
                                borderRadius: '12px',
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                            }}
                        >
                            <Box
                                sx={{
                                    // width: '5.4cm',
                                    // height: '8.6cm',
                                    width: '160px',
                                    height: '280px',
                                    // border: '1px solid #000000',
                                    // backgroundImage: `url(${backgroundImage})`,
                                    backgroundSize: '100% 100%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                }}
                            >
                                <img
                                    ref={logoRef}
                                    src={company?.photoUrl || logoImage}
                                    alt="Logo"
                                    crossOrigin="anonymous"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = logoImage;
                                    }}
                                    style={{
                                        filter: 'grayscale(100%)',
                                        marginTop: '15px',
                                        height: '40px',
                                        maxWidth: '75px',
                                        width: 'auto',
                                        objectFit: 'contain',
                                    }}
                                />

                                {loading ? (
                                    <CircularProgress />
                                ) : qrCodeImg ? (
                                    <Box
                                        sx={{
                                            width: '80%',
                                            border: '2px solid #000000',
                                            // border: '2px solid #134F99',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            overflow: 'hidden',
                                            backgroundColor: 'transparent',
                                            margin: 'auto',
                                        }}
                                    >
                                        <img
                                            src={qrCodeImg}
                                            alt="QR Code"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </Box>
                                ) : (
                                    <Typography>
                                        QR Code ainda não gerado
                                    </Typography>
                                )}

                                <img
                                    src={logoImage}
                                    alt="Logo"
                                    crossOrigin="anonymous"
                                    style={{
                                        filter: 'grayscale(100%)',
                                        width: '75px',
                                        objectFit: 'contain',
                                        marginBottom: '8px',
                                    }}
                                />

                                <Box
                                    sx={{
                                        marginBottom: '16px',
                                        border: '2px solid #000000',
                                        // border: '2px solid #134F99',
                                        borderRadius: '8px',
                                        // minWidth: '115px',
                                        // maxWidth: '115px',
                                        padding: '8px 16px',
                                        backgroundColor: '#FFFFFF',
                                        textAlign: 'center',
                                        minHeight: '41px',
                                        minWidth: '125.27px',
                                    }}
                                />
                            </Box>
                        </Box>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{ width: '100%' }}
                >
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleDownloadPNG}
                    sx={{ width: '100%' }}
                >
                    Baixar Cartão
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminCardDialog;
